import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Form, Formik } from "formik";
import * as Yup from "yup";

import moment from "moment";
import axios from "axios";
import history from "../router/history";
import { setConfirmationPageType } from "../reducers/stepsAction";
import {LoadingButton} from "../components/LoadingButton";
import { PageHeading } from "../components/PageHeading";
import AcceptTermsCard from "../components/Cards/AcceptTermsCard";
import PageStepCard from "../components/Cards/PageStepsCard";
import PriceInformationCard from "../components/PriceInformationCard";
import { setHouseCompany, acceptPersonalTerms, acceptConsentInformation } from '../reducers/simpleAction';

class SummarySignPage extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
        sendingMail: false,
        price: "",
        viewModelId: ""
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);

    let viewModelId = null;
    if(this.props.additionalInsurance.length > 0) {
      viewModelId = this.props.additionalInsurance[0].viewModelID;
      this.calculatedPrice(viewModelId);
    }
  }

  translateBool(bool) {
    if(bool) {
      return "Ja";
    }
    return "Nej";
  }

  stringEmpty(str) {
    if(str == null || str == "") {
      return true;
    }
    return false;
  }

  getCorrectValue(str) {
    if(this.stringEmpty(str)) {
      return null;
    }
    return str;
  }

  getSendData() {
    return {
      contact_information: {
        full_name: this.props.contact_information.first_name + " " + this.props.contact_information.last_name,
        phone: this.props.contact_information.phone,
        email: this.props.contact_information.email,
        social_security_number: this.props.contact_information.social_security_number,
        confirmation_email: this.props.contact_information.confirmationEmail
      },
      address_information: {
        street_address: this.props.contact_information.street_address,
        zip_code: this.props.contact_information.zip_code,
        city: this.props.contact_information.mailing_address,
        municipality: this.getCorrectValue(this.props.contact_information.municipality),
        current_street_address: this.getCorrectValue(this.props.contact_information.current_street_address),
        current_zip_code: this.getCorrectValue(this.props.contact_information.current_zip_code),
        current_city: this.getCorrectValue(this.props.contact_information.current_mailing_address)
      },
      apartment_information: {
        landlord: this.getCorrectValue(this.props.apartment_information.landlord),
        number_of_rooms: this.props.apartment_information.selected_number_of_rooms,
        security_door: this.props.apartment_information.security_door,
        payment_method: this.props.apartment_information.selected_payment_method.value,
      },
      insurance_information: {
        insurance_starts_at: this.props.apartment_information.insurance_start,
        comprehensive_insurance: this.props.apartment_information.comprehensive_insurance,
        increased_travel_protection: this.props.apartment_information.increased_travel_protection,
        personal_accident_insurance: this.props.apartment_information.personal_accident_insurance,
        tenant_insurance: this.props.apartment_information.tenant_insurance,
        small_boats_insurance: this.props.apartment_information.small_boats_insurance,
        selected_additional_jewelry_insurance: this.props.apartment_information.selected_additional_jewelry_insurance,
        
        personal_accident_insurances: {
          number_of_insurances: this.props.apartment_information.number_personal_accident_insurances == null ? 0 : this.props.apartment_information.number_personal_accident_insurances.key,
          
          first_full_name: this.getCorrectValue(this.props.apartment_information.first_personal_accident_insurances_name),
          first_social_security_number: this.getCorrectValue(this.props.apartment_information.first_personal_accident_insurances_ssn),
          
          second_full_name: this.getCorrectValue(this.props.apartment_information.second_personal_accident_insurances_name),
          second_social_security_number: this.getCorrectValue(this.props.apartment_information.second_personal_accident_insurances_ssn),
          
          third_full_name: this.getCorrectValue(this.props.apartment_information.third_personal_accident_insurances_name),
          third_social_security_number: this.getCorrectValue(this.props.apartment_information.third_personal_accident_insurances_ssn),
          
          fourth_full_name: this.getCorrectValue(this.props.apartment_information.fourth_personal_accident_insurances_name),
          fourth_social_security_number: this.getCorrectValue(this.props.apartment_information.fourth_personal_accident_insurances_ssn),
          
          fifth_full_name: this.getCorrectValue(this.props.apartment_information.fifth_personal_accident_insurances_name),
          fifth_social_security_number: this.getCorrectValue(this.props.apartment_information.fifth_personal_accident_insurances_ssn),
        },
      },

      other_information: this.props.apartment_information.other_information,
      contact_me: this.props.apartment_information.contact_me,
      contact_me_about: this.props.apartment_information.selected_contact_me_area,
      want_information_on: this.props.apartment_information.want_information_on,
      sent_at: moment().format("YYYY-MM-DD HH:mm"),
      housing_company: this.props.match.params.id,
      user_agent: window.navigator.userAgent
    };
  }

  sendInformation() {
    this.setState({
      sendingMail: true
    });
    
    let data = this.getSendData();
    let url = process.env.LF_API_URL + "/confirmation/housingcompany/";
    axios
      .post(url, data)
      .then(res => {
        this.props.history.push("/confirmation");
      })
      .catch(err => {
        alert("Ett fel har inträffat, kontakta vår support.");
        this.setState({
          sendingMail: false
        });
        console.error("Error in post: ", err.message);
      });
  }

  getCalcPriceData(viewModelId) {
    return {
      "viewModelID": viewModelId,
      "socialSecurityNumber": this.props.contact_information.social_security_number,
      "nrOfRooms": this.props.apartment_information.selected_number_of_rooms,
      "city": this.props.contact_information.mailing_address,
      "postalCode": this.props.contact_information.zip_code,
      "hasSecurityDoor": this.props.apartment_information.security_door,
      "comprehensiveInsurance": this.props.apartment_information.comprehensive_insurance,
      "personalAccidentInsurance": this.props.apartment_information.personal_accident_insurance,
      "nrOfPersons": this.props.apartment_information.number_personal_accident_insurances == null ? 0 : this.props.apartment_information.number_personal_accident_insurances.key,
      "increasedTravelProtection": this.props.apartment_information.increased_travel_protection,
      "tenantInsurance": this.props.apartment_information.tenant_insurance,
      "smallBoatsInsurance": this.props.apartment_information.small_boats_insurance
    }
  }

  calculatedPrice(viewModelId) {
    if(this.props.location.pathname.startsWith("/kund")) {
      let data = this.getCalcPriceData(viewModelId);
      let url = process.env.LF_API_URL + "/homeinsurance/calculateprice/";
      
      axios
        .post(url, data)
        .then(data => {
          this.setState({
            price: data.data.price.replace(".", " ")
          });
        })
        .catch(err => {
          alert("Ett fel har inträffat när pris räknades ut, kontakta vår support.");
          console.error("Error in post: ", err.message);
        });
    }
  }

  getRow(title, value, key) {
    if (value == "" || value == " " || value == null) {
      return "";
    }
    
    return (
      <tbody key={key}>
        <tr className="d-md-none">
          <td className="firstTd" colSpan="2">
            <strong>{title}</strong>
          </td>
        </tr>
        <tr className="d-md-none">
          <td className="bt-0" colSpan="2">
            {value}
          </td>
        </tr>

        <tr className="d-none d-md-table-row">
          <td className="firstTd">{title}</td>
          <td>{value}</td>
        </tr>
      </tbody>
    );
  }
  
  render() {
    let data = this.getSendData();
    
    const priceInformation = this.props.location.pathname.startsWith("/kund") ? <div className="card mt-4">
        <table className="table mt-1">
          <caption className="card-header">Prisuppgift</caption>
          {this.getRow( "Priset på din försäkring (per år):", this.state.price, i++ )}
        </table>
      </div>
    : null;

    let i = 1;

    let insuranceAddress = data.address_information.street_address + " " + data.address_information.zip_code + " " + data.address_information.city;

    let currentAddress = null;
    if (data.address_information.current_street_address != null) {
      currentAddress = data.address_information.current_street_address + " " + data.address_information.current_zip_code + " " + data.address_information.current_city;
    }

    const mandatoryField = "Detta fält är obligatoriskt";
    let validationSchema = Yup.object().shape({
      personalTermsAccepted: Yup.bool().oneOf([true], mandatoryField),
      consentInformationAccepted: Yup.bool().oneOf([true], mandatoryField),
    });

    return (
      <div className="container mt-4 mb-4">
        <PageHeading title="Köp hemförsäkring" customer="true" history={this.props.history} urlParams={this.props.match.params} />
        <div className="row">
          <div className="col-lg-8">
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-12">
                    Din försäkringsgivare är Länsförsäkringar Skåne.<br />
                    Kontrollera noga att nedanstående uppgifter är riktiga. Din beställning genomförs inte förrän du trycker på "Bekräfta köp".
                  </div>
                </div>
              </div>
            </div>

            {priceInformation}
            
            <div className="card mt-4">
              <table className="table mt-1">
                <caption className="card-header">Uppgifter</caption>

                {this.getRow( "Namn", data.contact_information.full_name, i++ )}
                {this.getRow( "Telefonnummer", data.contact_information.phone, i++ )}
                {this.getRow( "E-Mailadress", data.contact_information.email, i++ )}
                {this.getRow( "Personnummer", data.contact_information.social_security_number, i++ )}

                {this.getRow( "Adress till bostaden som ska försäkras", insuranceAddress, i++ )}
                
                {this.getRow( "Min nuvarande adress", currentAddress, i++)}

                {this.getRow( "Bostadsrättsförening/Hyresvärd", data.apartment_information.landlord, i++ )}
                
                {
                  (this.props.showSecurityDoor ? 
                    this.getRow( "Säkerhetsdörr finns (ger 10% rabatt)", this.translateBool(data.apartment_information.security_door), i++ ) : null)
                }

                {this.getRow( "Försäkringen ska börja gälla", data.insurance_information.insurance_starts_at, i++ )}
                {this.getRow( "Antal rum", data.apartment_information.number_of_rooms, i++ )}
                
                {
                  (data.apartment_information.payment_method != undefined) ?
                    this.getRow( "Betalningssätt", data.apartment_information.payment_method.value, i++ ) : null
                }
                
                {
                  (this.props.additionalInsurance.filter((e) => e.additionalInsuranceType === 0).length > 0) ?
                    this.getRow( "Allriskförsäkring", this.translateBool(data.insurance_information.comprehensive_insurance), i++ ) : null
                }
                {
                  (this.props.additionalInsurance.filter((e) => e.additionalInsuranceType === 1).length > 0) ?
                    this.getRow( "Privat olycksfallsförsäkring", this.translateBool(data.insurance_information.personal_accident_insurance), i++ ) : null
                }
                {
                  (this.props.additionalInsurance.filter((e) => e.additionalInsuranceType === 2).length > 0) ?
                    this.getRow( "Utökat reseskydd", this.translateBool(data.insurance_information.increased_travel_protection), i++ ) : null
                }
                {
                  (this.props.additionalInsurance.filter((e) => e.additionalInsuranceType === 3).length > 0) ?
                    this.getRow( "Bostadsrättsförsäkring", this.translateBool(data.insurance_information.tenant_insurance), i++ ) : null
                }
                {
                  (this.props.additionalInsurance.filter((e) => e.additionalInsuranceType === 4).length > 0) ?
                    this.getRow( "Småbåtsförsäkring", this.translateBool(data.insurance_information.small_boats_insurance), i++ ) : null
                }
                
                {
                  (data.insurance_information.personal_accident_insurances.number_of_insurances > 0 )
                  ? this.getRow( "Privat olycksfallsförsäkring (person 1)", data.insurance_information.personal_accident_insurances.first_full_name + " " + data.insurance_information.personal_accident_insurances.first_social_security_number, i++ )
                  : null
                }

                {
                  (data.insurance_information.personal_accident_insurances.number_of_insurances > 1)
                  ? this.getRow( "Privat olycksfallsförsäkring (person 2)", data.insurance_information.personal_accident_insurances.second_full_name + " " + data.insurance_information.personal_accident_insurances.second_social_security_number, i++ )
                  : null
                }

                {
                  (data.insurance_information.personal_accident_insurances.number_of_insurances > 2 && data.insurance_information.personal_accident_insurances.third_social_security_number != "")
                  ? this.getRow( "Privat olycksfallsförsäkring (person 3)", data.insurance_information.personal_accident_insurances.third_full_name + " " + data.insurance_information.personal_accident_insurances.third_social_security_number, i++ )
                  : null
                }

                {
                  (data.insurance_information.personal_accident_insurances.number_of_insurances > 3 && data.insurance_information.personal_accident_insurances.fourth_social_security_number != "")
                  ? this.getRow( "Privat olycksfallsförsäkring (person 4)", data.insurance_information.personal_accident_insurances.fourth_full_name + " " + data.insurance_information.personal_accident_insurances.fourth_social_security_number, i++ )
                  : null
                }

                {
                  (data.insurance_information.personal_accident_insurances.number_of_insurances > 4 && data.insurance_information.personal_accident_insurances.fifth_social_security_number != "")
                  ? this.getRow( "Privat olycksfallsförsäkring (person 5)", data.insurance_information.personal_accident_insurances.fifth_full_name + " " + data.insurance_information.personal_accident_insurances.fifth_social_security_number, i++ )
                  : null
                }
                
                {this.getRow( "Smycken och armbandsklockor", data.insurance_information.selected_additional_jewelry_insurance ? "Ja, kontakta mig" : "Nej, 200 000 kr räcker som ersättningsbelopp", i++ )}

                {this.getRow( "Övrig information", data.other_information, i++ )}
                
                {this.getRow( "Kontakta mig för mer information", this.translateBool(data.contact_me), i++ )}
                {this.getRow( "Kontakta mig om", data.contact_me_about, i++ )}
                {this.getRow( "Jag vill ha information om", data.want_information_on, i++ )}
                
              </table>
            </div>
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-12">
                      <strong>Ångerrätt</strong>
                      <p>
                        Enligt Distansavtalslagen har du 14 dagars ångerrätt när du tecknar försäkring via Internet. Läs mer om din möjlighet att ångra köpet i informationen nedan.
                      </p>
                      <strong>Viktig information att läsa igenom</strong>
                      {this.props.attachments.map((attachment, key) =>
                        <div key={key}>
                          <a target="_blank" href={attachment.aHrefPath}> {attachment.aHrefName} </a>
                        </div>
                      )}
                      <div>
                        <a target="_blank" href="http://www.lansforsakringar.se/skane/privat/forsakring/hemforsakring/hyresratt/">Villkor försäkring</a>
                      </div>
                      <div>
                        <a target="_blank" href="http://www.lansforsakringar.se/privat/Sidor/Pul.aspx">Behandling av personuppgifter</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            <Formik
              initialValues={{ 
                personalTermsAccepted: this.props.personal_terms_accepted,
                consentInformationAccepted: this.props.consent_information_accepted,
              }}
              validationSchema={validationSchema}
              onSubmit={fields => {
                this.sendInformation();
              }}
              >
                {(formikProps) =>
                  <Form>
                    <AcceptTermsCard {...formikProps} />
                    <PageStepCard {...formikProps} history={this.props.history} step="3" sendingMail={this.state.sendingMail}/>
                  </Form>
                }
              </Formik>
          </div>

          <div className="col-lg-4">
            <div className="sidebar">
              <PriceInformationCard />
            </div>
          </div>

        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    data: state,
    apartment_information: state.apartmentReducer.apartment_information,
    showSecurityDoor: state.simpleReducer.textSections.securityDoor,
    contact_information: state.contactReducer.contact_information,
    personal_terms_accepted: state.simpleReducer.personal_terms_accepted,
    consent_information_accepted: state.simpleReducer.consent_information_accepted,
    additionalInsurance: state.simpleReducer.additionalInsurance,
    attachments: state.simpleReducer.attachments,
    consentInformation: state.simpleReducer.textSections.consentInformation,
    consentCheckboxInformation: state.simpleReducer.textSections.consentCheckboxInformation,
    timeUnit: state.simpleReducer.textSections.timeUnit
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setConfirmationPageType: bindActionCreators( setConfirmationPageType, dispatch ),
    setHouseCompany: bindActionCreators(setHouseCompany, dispatch),
    acceptPersonalTerms: bindActionCreators(acceptPersonalTerms, dispatch),
    acceptConsentInformation: bindActionCreators(acceptConsentInformation, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SummarySignPage);
